<i18n src="@/lang/actions.json"></i18n>

<i18n>
    {
    "en": {
    "widgets-title": "Widgets"
    },
    "ua": {
    "widgets-title": "Віджети"
    },
    "ru": {
    "widgets-title": "Виджеты"
    }
    }
</i18n>

<template>
  <el-main>
    <header_actions>
      <template slot="button-group">
        <el-button v-t="'actions.add_new'" @click="handleAddNew" />
      </template>
    </header_actions>
    <br />
    <el-container class="widgets" style="padding-top: 20px">
      <component
        v-for="(widget, index) in widgets"
        :key="widget.uuid"
        :is="require('./elements/widget_card').default"
        :widget.sync="widgets[index]"
        is_in_widgets
      />
    </el-container>
  </el-main>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Header_actions from "../_snippets/header_actions/header_actions";

export default {
  name: "widgets_list",
  components: { Header_actions },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions("shared_widgets_list", ["getData"]),
    ...mapMutations("shared_widgets_list", ["addFirst"]),
    handleAddNew() {
      this.addFirst();
    }
  },
  computed: {
    ...mapGetters({
      widgets: "shared_widgets_list/widgets"
    })
  }
};
</script>

<style scoped lang="stylus">
.widgets {
    display: flex;
    flex-wrap: wrap;
}
</style>

<style lang="stylus">
.el-header.actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 10px;
}

.widgets {
    background-color: #fff;
}
</style>
